export default "__VITE_ASSET__CzptdVj1__"